import { v4 as uuid } from 'uuid';
import { map } from 'lodash';
import { toUUID } from '../../util/transform';
import HomeLoanProductCommission from './HomeLoanProductCommission';
import type { IHomeLoanCompareProductSplit } from './HomeLoanCompareProductSplit.interface';

export default class HomeLoanCompareProductSplit implements IHomeLoanCompareProductSplit {
  id: string;
  idParent: string;
  idProduct: string;
  productName: string;
  totalLoanAmount: number;
  loanTerm: number;
  interestRate: number;
  revertRate: number;
  comparisonRate: number;
  absLendingPurposeCode: any;
  fixedTerm: number;
  interestOnlyTerm: number;
  isInterestOnly: number;
  repayment1: number;
  repayment1Info: string;
  repayment2: number;
  repayment2Info: string;
  repayment3: number;
  repayment3Info: string;
  principalBalances: Array<number>;
  principalOffsetBalances: Array<number>;
  maximumBorrowing: number;
  commissions: HomeLoanProductCommission;

  static build = (data: IHomeLoanCompareProductSplit) => new HomeLoanCompareProductSplit(data);
  static blank = () => new HomeLoanCompareProductSplit();

  /**
   * Constructor
   * @param {IHomeLoanCompareProductSplit} data
   */
  constructor(data?: IHomeLoanCompareProductSplit) {
    this.id = toUUID(data?.id) || uuid();
    this.idParent = data?.idParent || '';
    this.idProduct = data?.idProduct || '';
    this.productName = data?.productName || '';
    this.totalLoanAmount = parseFloat(data?.totalLoanAmount || 0);
    this.loanTerm = parseFloat(data?.loanTerm || 0);
    this.interestRate = parseFloat(data?.interestRate || 0);
    this.revertRate = parseFloat(data?.revertRate || 0);
    this.comparisonRate = parseFloat(data?.comparisonRate || 0);
    this.absLendingPurposeCode = data?.absLendingPurposeCode || undefined;
    this.fixedTerm = parseFloat(data?.fixedTerm || 0);
    this.interestOnlyTerm = parseFloat(data?.interestOnlyTerm || 0);
    this.isInterestOnly = parseFloat(data?.isInterestOnly || 0);
    this.repayment1 = parseFloat(data?.repayment1 || 0);
    this.repayment1Info = data?.repayment1Info || '';
    this.repayment2 = parseFloat(data?.repayment2 || 0);
    this.repayment2Info = data?.repayment2Info || '';
    this.repayment3 = parseFloat(data?.repayment3 || 0);
    this.repayment3Info = data?.repayment3Info || '';
    this.principalBalances = map(data?.principalBalances || [], (i) => parseFloat(i || 0));
    this.principalOffsetBalances = map(data?.principalOffsetBalances || [], (i) =>
      parseFloat(i || 0)
    );
    this.maximumBorrowing = parseFloat(data?.maximumBorrowing || 0);
    this.commissions = new HomeLoanProductCommission(data?.commissions);
  }
}
